import moment from "moment";
import { DataExportComponent } from "../data-export.component";

export type ExportFormValue = ReturnType<DataExportComponent["exportForm"]["getRawValue"]>;
export class ExportRequestDTO {
  temporaryChanges: boolean;
  postProccessing: string;
  icaoDataset?: string;
  format?: string;
  effectiveDate: string;

  static parseToPayload(data: ExportFormValue): ExportRequestDTO {
    const payload = new ExportRequestDTO();
    payload.effectiveDate = (data.effectiveDate as moment.Moment).toISOString();
    payload.temporaryChanges = data.temporaryChanges;
    payload.postProccessing = data.postProccessing;
    payload.format = data.format;
    return payload;
  }

  static parseToForm(data: ExportRequestDTO): ExportFormValue {
    return {
      effectiveDate: moment(data.effectiveDate),
      format: data.format,
      icaoDataset: data.icaoDataset ?? null,
      temporaryChanges: data.temporaryChanges,
      postProccessing: data.postProccessing,
    };
  }
}

export class ExportJob {
  exportRequestDTO: ExportRequestDTO;
  datasetUuid: string;
  conversionUuid: string;
  exportStatus: string;
  exportMessage: string;
  exportDate: string;

  constructor(init?: Partial<ExportJob>) {
    Object.assign(this, init);
  }
}
